module.exports = __webpack_public_path__ + "static/logo_malakoff_mederic_rvb-37cbca289e8ac625c62c3318561beeb4.svg";